import React from "react";
import { Button, Column, getObjectKeys, If, Row, toGrammaticalNumber } from "@hex-insights/core";
import { ContractInstallmentComponents } from "@hex-insights/verita-romania.shared";
import { contractPaymentOptions } from "../../payment-plans";
import styles from "./styles.module.css";

export type NumPaymentsFieldProps = {
	numPayments: number;
	setNumPayments: (numPayments: number) => void;
	totalPrice: number;
	disabled?: boolean;
};

export function NumPaymentsField({ numPayments, setNumPayments, totalPrice, disabled }: NumPaymentsFieldProps) {
	const contractInstallments = React.useMemo(() => {
		return (
			contractPaymentOptions[numPayments]?.map((dueDate) => ({
				id: dueDate,
				dueDate,
				portion: 1,
			})) ?? []
		);
	}, [numPayments]);

	return (
		<Column justify="spaced-start" verticalSpacing="1rem">
			<Row
				justify="spaced-start"
				align="center"
				horizontalSpacing="0.5rem"
				withVerticalSpacing
				verticalSpacing="0.5rem"
				overflow="wrap"
			>
				{getObjectKeys(contractPaymentOptions)
					.sort()
					.map((npString) => {
						const np = Number(npString);

						return (
							<Button
								key={np}
								variant={np === numPayments ? "primary" : "secondary"}
								onClick={() => {
									if (disabled) {
										return;
									}
									setNumPayments(np);
								}}
								disabled={disabled}
							>
								{toGrammaticalNumber("Payment", np, true)}
							</Button>
						);
					})}
			</Row>

			<If condition={numPayments === 4}>
				<span className={styles["payment-plan__fee-notice"]}>
					Please note that when issuing the contract, a 2% surcharge will be applied to the tuition and meal plan when
					choosing 4 payments.
				</span>
			</If>

			<If condition={numPayments === 9}>
				<span className={styles["payment-plan__fee-notice"]}>
					Please note that when issuing the contract, a 5% surcharge will be applied to the tuition and meal plan when
					choosing 9 payments.
				</span>
			</If>

			<ContractInstallmentComponents.ContractInstallmentsTable
				totalPrice={totalPrice}
				contractInstallments={contractInstallments}
				hidePortion
				className={styles["num-payments-field__installments-table"]}
			/>
		</Column>
	);
}
